// import { take, call, put, select } from 'redux-saga/effects';

// Individual exports for testing
export default function* patientSaga() {
	// See example in containers/HomePage/saga.js
}
